import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/app.css';
import { App } from '@/app/App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('找不到 #root 掛載點');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
